import { render, staticRenderFns } from "./Tutors.vue?vue&type=template&id=c48b793c&scoped=true"
import script from "./Tutors.vue?vue&type=script&lang=js"
export * from "./Tutors.vue?vue&type=script&lang=js"
import style0 from "./Tutors.vue?vue&type=style&index=0&id=c48b793c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48b793c",
  null
  
)

export default component.exports